import { Component, OnInit } from '@angular/core';
import { PageBaseComponent } from './page-base.component';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService, DatasourceService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { PagerSettings } from "@progress/kendo-angular-listview";
import { environment } from '@environments/environment';


@Component({
  selector: 'expenses',
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-list.css'],
  template: `

    <div class="wrapper-route">
    
      <div class="row" style="padding-bottom: 8px;">        
        <div class="col-xs-12 col-sm-12 example-col">
          <kendo-textbox [clearButton]="true" (valueChange)="onSearchChange($event)" style="width: 100%">
            <ng-template kendoTextBoxPrefixTemplate>
              <button kendoButton look="clear" icon="search"></button>
              <kendo-textbox-separator></kendo-textbox-separator>
            </ng-template>
          </kendo-textbox>
        </div>
      </div>
      
      <div class="row" style="padding-bottom: 8px; padding-left: 12px; padding-top: 4px;" *ngIf="!loading && data.length == 0">        
        <div class="col-xs-12 col-sm-12 example-col list-header" style="text-align: center">
          <kendo-label text="Sin resultados."></kendo-label>
        </div>
      </div>

      <div class="k-block" *ngIf="loading">
        <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
      </div>    

      <kendo-listview [kendoListViewBinding]="data" [pageable]="pagerSettings" [pageSize]="pageSize" containerClass="k-d-flex k-flex-col k-flex-nowrap" *ngIf="!loading && data.length">
        <ng-template kendoListViewHeaderTemplate>
          <div class="list-header">Lista de gastos</div>
        </ng-template>
        <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
          <expense-card class="card" [expense]="dataItem" [returnUrl]="'expenses'" [borderTop]="!isFirst"></expense-card>
        </ng-template>
        <!--<ng-template kendoListViewFooterTemplate>
          <div class="list-footer">{{total}} productores</div>
        </ng-template>-->
      </kendo-listview>

      <kendo-floatingactionbutton icon="plus" themeColor="success" [offset]="{ x: '20px', y: '75px' }" [align]="{ vertical: 'bottom', horizontal: 'end' }" positionMode="fixed" (click)="goAddExpense()" *ngIf="authService.hasPermission(['GASTOS:NUEVO'])"></kendo-floatingactionbutton>

    </div>

  `
})
export class ExpensesComponent extends PageBaseComponent implements OnInit {

  public data: any[];

  public total: number;

  public pagerSettings: PagerSettings = {
    previousNext: true,
    pageSizeValues: false,
    buttonCount: 9,
  };

  public pageSize = 10;

  public defaultImage: string = environment.assets.DEFAULT_VEHICLE;

  protected id_tecnico: number = 0;

  protected search: string = '';

  protected searchColumns: any[] = [
    'cost',    
    'date',
    'description',
    'expense_type_name',
    'payment_type_name',
    'person_authorize_name',
    'supplier'
  ];


  constructor(public authService: AuthService, protected router: Router, protected service : DatasourceService, private http: HttpClient) { 

    super(authService, router)
    this.id_tecnico = this.currentUser.id;
    console.log('ExpensesComponent');

  }

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.take = 0;
    s.sort = [      
      {field: 'date', dir: 'desc'}
    ];
    s.filter = {
      logic: "or",
      filters: []
    }

    if(this.search != ''){
      s.filter.filters = this.searchColumns.map(item => {
        return {
          field: item,
          operator: 'contains',
          value: this.search
        }
      });
    }

    return s;

  }

  ngOnInit() { 
    
    this.update();

  }

  public onSearchChange(value: any): void {

    this.search = value;

    this.update();

  }

  public update() {

    this.loading = true;

    this.state = this.getInitialState();

    this.service.search('expenses_inventories', this.state)
      .subscribe(
        (result: any) => {
          console.log(result);
          this.data = result.data;
          this.total = result.total;

          this.loading = false;
        },
        (error: any) => {
          console.log(error)
          // this.loading = false;
        });

  }

  public goAddExpense() {

    this.router.navigate(['/expense_new']);

  }

}